<main
  class="container-fluid tw-flex tw-min-h-96 tw-max-w-2xl tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-py-36"
>
  <img [src]="getImgSrc()" alt="thank you" />
  <h1 class="tw-text-center tw-font-body tw-font-bold tw-text-primary">{{ getTitle() | translate }}</h1>
  <div>
    <p class="tw-text-center tw-text-black" *ngIf="!investmentId; else unpaidSubtitle">
      {{ getSubtitle() | translate }}
    </p>
    <p class="tw-text-center tw-text-black">{{ getParagraph() | translate }}</p>
  </div>
  <div class="tw-flex tw-w-full tw-flex-col tw-gap-4 md:tw-flex-row-reverse">
    @if (investmentId) {
      <a
        class="tw-w-full tw-rounded-md tw-bg-primary tw-py-4 tw-text-center tw-font-semibold tw-text-white hover:tw-text-white"
        [routerLink]="['/equity', campaignSlug, 'invest-now', 'payment', investmentId]"
        routerLinkActive="router-link-active"
      >
        {{ 'investment.payNow' | translate }}
      </a>
      <a
        class="tw-w-full tw-rounded-md tw-border tw-bg-white tw-py-4 tw-text-center"
        [routerLink]="['/equity']"
      >
        {{ 'investment.browseMoreCampaigns' | translate }}
      </a>
    } @else {
      <a
        class="tw-w-full tw-rounded-md tw-bg-primary tw-py-4 tw-text-center tw-font-semibold tw-text-white hover:tw-text-white"
        routerLink="/equity"
        routerLinkActive="router-link-active"
      >
        {{ 'investment.browseMoreCampaigns' | translate }}
      </a>
      <a
        class="tw-w-full tw-rounded-md tw-border tw-bg-white tw-py-4 tw-text-center tw-font-semibold tw-text-body-dark hover:tw-bg-gray-50"
        routerLink="/dashboard/pledges"
      >
        {{ 'investment.viewMyInvestments' | translate }}
      </a>
    }
  </div>
</main>

<ng-template #unpaidSubtitle>
  <p class="tw-text-center tw-text-black">
    {{ 'investment.pledgePrefix' | translate }}
    <span class="tw-font-semibold tw-underline">{{ 'investment.payNow' | translate }}</span>
    {{ 'investment.pledgeSuffix' | translate }}
  </p>
</ng-template>
